<template>
<div class="wrapper" :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive }
    ]">
    <notifications></notifications>
    <side-bar :active-color="sidebarBackground" :data-background-color="sidebarBackgroundColor">
        <user-menu></user-menu>
        <mobile-menu></mobile-menu>
        <template slot="links">
            <sidebar-item :link="{ name: 'DASHBOARD', icon: 'fas fa-th-large text-info', path: '/dashboard' }"></sidebar-item>
            <sidebar-item v-if="permissoes.pagamentosCreate && nivel != 12" :link="{ name: 'PAGAMENTO', icon: 'fas fa-credit-card text-info', path: '/pagamentos' }" />
            <sidebar-item v-if="permissoes.abastecimentosCreate" :link="{ name: 'ABASTECIMENTO', icon: 'fas fa-gas-pump text-info', path: '/abastecimentos' }" />
            <cliente />
            <empresa />
            <usuario />
            <plano />
            <frota />
            <financeiro />
            <configuracao />
            <sidebar-item v-if="permissoes.parcelamentosCreate" :link="{ name: 'PARCELAMENTO', icon: 'fas fa-money-check-alt text-info', path: '/pagamentos/parcelamentos' }" />
            <sidebar-item v-if="permissoes.smsRead" :link="{ name: 'SMS', icon: 'fas fa-sms text-info', path: '/sms' }" />
            <sidebar-item v-if="permissoes.relatoriosView" :link="{ name: 'RELATÓRIOS', icon: 'fas fa-list-alt text-info', path: '/relatorios' }" />
            <sidebar-item color='red' @click.native="logout" :link="{ name: 'SAIR', icon: 'fas fa-power-off icon-red', path: '/' }"></sidebar-item>
        </template>
    </side-bar>
    <div class="main-panel">
        <top-navbar></top-navbar>

        <fixed-plugin :color.sync="sidebarBackground" :colorBg.sync="sidebarBackgroundColor" :sidebarMini.sync="sidebarMini">
        </fixed-plugin>

        <div :class="{ content: !$route.meta.hideContent }" @click="toggleSidebar">
            <zoom-center-transition :duration="200" mode="out-in">
                <!-- your content here -->
                <router-view></router-view>
            </zoom-center-transition>
        </div>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
</div>
</template>

<script>
/* eslint-disable no-new */
function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
    if (hasElement(className)) {
        new PerfectScrollbar(`.${className}`);
        document.getElementsByClassName(className)[0].scrollTop = 0;
    } else {
        // try to init it later in case this component is loaded async
        setTimeout(() => {
            initScrollbar(className);
        }, 100);
    }
}

function reinitScrollbar() {
    let docClasses = document.body.classList;
    let isWindows = navigator.platform.startsWith("Win");
    if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar("sidebar");
        initScrollbar("sidebar-wrapper");
        initScrollbar("main-panel");

        docClasses.add("perfect-scrollbar-on");
    } else {
        docClasses.add("perfect-scrollbar-off");
    }
}
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import {
    usuarioKey
} from '@/global'
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import FixedPlugin from "./FixedPlugin.vue";
import UserMenu from "./Extra/UserMenu.vue";
import Usuario from "@/pages/Layout/Sidebar/Usuario";
import Configuracao from "@/pages/Layout/Sidebar/Configuracao";
import Empresa from "@/pages/Layout/Sidebar/Empresa";
import Cliente from "@/pages/Layout/Sidebar/Cliente";
import Plano from "@/pages/Layout/Sidebar/Plano";
import Frota from "@/pages/Layout/Sidebar/Frota";
import Financeiro from "@/pages/Layout/Sidebar/Financeiro";

export default {
    components: {
        TopNavbar,
        ContentFooter,
        FixedPlugin,
        MobileMenu,
        UserMenu,
        Usuario,
        Configuracao,
        Empresa,
        Cliente,
        Plano,
        Frota,
        Financeiro
    },
    data() {
        return {
            permissoes: this.$store.state.usuario.permissao,
            nivel: this.$store.state.usuario.niveis[0].id,
            sidebarBackgroundColor: "black",
            sidebarBackground: "site",
            sidebarMini: true,     

        };
    },

    created () {
        this.sidebarMini = false;
    },

    methods: {
        toggleSidebar() {
            if (this.$sidebar.showSidebar) {
                this.$sidebar.displaySidebar(false);
            }
        },

        minimizeSidebar() {
            if (this.$sidebar) {
                this.$sidebar.toggleMinimize();
            }
        },

        logout() {
            this.$http.get(this.$urlAPI + 'logout')
            localStorage.clear();
            this.$store.commit('setUsuario', null)
            this.$router.push({
                name: 'login'
            });
        }

    },
    updated() {
        reinitScrollbar();
    },
    mounted() {
        reinitScrollbar();
    },
    watch: {
        sidebarMini() {
            this.minimizeSidebar();
        }
    }
};
</script>

<style lang="scss">
$scaleSize: 0.95;

@keyframes zoomIn95 {
    from {
        opacity: 0;
        transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }

    to {
        opacity: 1;
    }
}

.main-panel .zoomIn {
    animation-name: zoomIn95;
}

@keyframes zoomOut95 {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
        transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
}

.main-panel .zoomOut {
    animation-name: zoomOut95;
}
</style>
